import ObservationDoneIcon from '@assets/images/observation-status-done-icon.svg?react'
import ObservationContestedIcon from '@assets/images/observation-status-contested-icon.svg?react'
import ObservationRecoveryIcon from '@assets/images/observation-status-recovery-icon.svg?react'

import FormDoneIcon from '@assets/images/form-status-done-icon.svg?react'
import FormInProgressIcon from '@assets/images/form-status-in-progress-icon.svg?react'

import TaskWarningIcon from '@assets/images/task-status-warning-icon.svg?react'

import ToDoIcon from '@assets/images/observation-status-todo-icon.svg?react'

import { FormStatus, ObservationStatus, TaskStatus } from '@types'

interface MarkerStatusIconProps {
  status: ObservationStatus | FormStatus | TaskStatus
}

const statusColors: Record<ObservationStatus | FormStatus | TaskStatus, string> = {
  [ObservationStatus.StatusToDo]: 'transparent',
  [ObservationStatus.StatusContested]: '#EB4747',
  [ObservationStatus.StatusPlannedRecovery]: '#EB4747',
  [ObservationStatus.StatusValidatedByReader]: '#FF8F00',
  [ObservationStatus.StatusValidatedByCustomer]: '#4D4BE7',
  [ObservationStatus.StatusValidatedByAdmin]: '#2FB609',
  [FormStatus.StatusDone]: '#2FB609',
  [FormStatus.StatusInProgress]: '#FF8F00',
  [TaskStatus.StatusWarning]: '#EB4747',
}

const icons: Record<FormStatus | ObservationStatus | TaskStatus, React.ReactElement> = {
  [ObservationStatus.StatusToDo]: <ToDoIcon fill="white" />,
  [ObservationStatus.StatusContested]: <ObservationContestedIcon />,
  [ObservationStatus.StatusPlannedRecovery]: <ObservationRecoveryIcon />,
  [ObservationStatus.StatusValidatedByAdmin]: <ObservationDoneIcon />,
  [ObservationStatus.StatusValidatedByCustomer]: <ObservationDoneIcon />,
  [ObservationStatus.StatusValidatedByReader]: <ObservationDoneIcon />,
  [FormStatus.StatusDone]: <FormDoneIcon />,
  [FormStatus.StatusInProgress]: <FormInProgressIcon />,
  [TaskStatus.StatusWarning]: <TaskWarningIcon />,
}

export const MarkerStatusIcon = ({ status }: MarkerStatusIconProps): JSX.Element => {
  return (
    <div style={{ width: '22px' }}>
      <div
        style={{
          height: '20px',
          width: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxSizing: 'border-box',
          borderRadius: '50%',
          border: status === ObservationStatus.StatusToDo ? '0' : '2px solid var(--Persistent-White, #fff)',
          background: statusColors[status],
          boxShadow:
            status === ObservationStatus.StatusToDo
              ? '0'
              : '0px 2px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1)',
        }}
      >
        {icons[status]}
      </div>
    </div>
  )
}
